module.exports = "/_next/static/images/landing3-mobile-d208f3ba8feadbe998bcd09a7c8dfbb8.png";